<div class="main-page">
  <div class="integritycheck-wrapper">
    <div class="integritycheck-title">New Version Available</div>
    <div class="integritycheck-content">You don’t have access to the app. To restore your access, you must download it again.</div>
    
    <div class="integritycheck-title">Nouvelle version accessible</div>
    <div class="integritycheck-content">Vous n’avez pas accès à l’application. Pour rétablir votre accès, vous devez la télécharger à nouveau.</div>
  </div>
</div>